import {
  LOGIN,
  SET_USER_INFO,
  SET_EMAIL,
  SET_PASSWORD,
  SET_USERNAME,
  SET_PHONE_NUMBER,
  REGISTER,
  IS_SHOW_LOGIN_MODAL,
  IS_SHOW_REGISTER_MODAL,
  IS_SHOW_UPDATE_USER_MODAL,
  IS_EXPIRED_LOGIN,
  SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES,
  SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES,
} from '../constants';

export default function user(state = null, action) {
  if (state === null) {
    return {
      email: '',
      password: '',
      name: '',
      phone: '',
      has_agreed_to_receive_gogovan_updates: false,
      has_agreed_to_receive_third_parties_updates: false,
      user: null,
      isShowLoginModal: false,
      isShowRegisterModal: false,
      isShowUpdateUserModal: false,
      isShowExpiredLoginModal: false,
    };
  }

  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        email: action.payload.email,
        password: action.payload.password,
      };
    case SET_USER_INFO:
      return {
        ...state,
        user: action.payload,
      };
    case REGISTER:
      return {
        ...state,
        email: action.payload.email,
        password: action.payload.password,
        phone: action.payload.phone,
        name: action.payload.name,
      };
    case SET_EMAIL:
      return {
        ...state,
        email: action.payload,
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };
    case SET_USERNAME:
      return {
        ...state,
        name: action.payload,
      };
    case SET_PHONE_NUMBER:
      if (!Number.isNaN(parseInt(action.payload, 10))) {
        return {
          ...state,
          phone: action.payload,
        };
      }
      return {
        ...state,
      };
    case IS_SHOW_LOGIN_MODAL:
      return {
        ...state,
        isShowLoginModal: !state.isShowLoginModal,
      };
    case IS_SHOW_REGISTER_MODAL:
      return {
        ...state,
        isShowRegisterModal: !state.isShowRegisterModal,
      };
    case IS_SHOW_UPDATE_USER_MODAL:
      return {
        ...state,
        isShowUpdateUserModal: !state.isShowUpdateUserModal,
      };
    case IS_EXPIRED_LOGIN:
      return {
        ...state,
        isShowExpiredLoginModal: !state.isShowExpiredLoginModal,
      };
    case SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES:
      return {
        ...state,
        has_agreed_to_receive_gogovan_updates: !state.has_agreed_to_receive_gogovan_updates,
      };
    case SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES:
      return {
        ...state,
        has_agreed_to_receive_third_parties_updates: !state.has_agreed_to_receive_third_parties_updates,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js